import { FC } from "react";

export const HubspotFormHack: FC = () => {
  return (
    <>
      {/* HACK: HubspotCollectedFormsWorkaround
                https://community.hubspot.com/t5/APIs-Integrations/How-to-stop-collected-forms-from-collecting-a-form/m-p/299172#M28102 */}
      <label htmlFor="cc-num" className="hidden"></label>
      <input
        name="cc-num"
        className="hidden"
        required
        value="HubspotCollectedFormsWorkaround"
        id="cc-num"
        onChange={() => {}}
      />
    </>
  );
};
